export default __webpack_public_path__ + "static/media/anambra-sectariat.c2e53553.jpg";